"use strict";
/* Copyright (c) 2022 Xperi. All Rights Reserved. */
Object.defineProperty(exports, "__esModule", { value: true });
exports.Operations = void 0;
var AnalyticsConstants_1 = require("./AnalyticsConstants");
var EventQueue_1 = require("./eventqueue/EventQueue");
var EventQueueHandler_1 = require("./eventqueue/EventQueueHandler");
var OperationsLogger_1 = require("./loggers/OperationsLogger");
var NoTransport_1 = require("./transports/NoTransport");
var Operations = /** @class */ (function () {
    function Operations() {
    }
    Operations.logOperationsEvent = function (finalPayload) {
        if (Operations.isSynchronised) {
            Operations.eventQueue.add(finalPayload);
            Operations.eventQueuehandler.startDequeueing();
        }
        else
            Operations.logger.log(finalPayload);
    };
    Operations.setGlobals = function (payload) {
        Operations.globals = payload;
    };
    Operations.synchronised = function (value) {
        Operations.isSynchronised = value;
    };
    Operations.getInstance = function () {
        return Operations.logger;
    };
    Operations.disabled = function () {
        this.logger.isDisabled = true;
        this.logger.setTransport(new NoTransport_1.NoTransport());
    };
    Operations.log = function (data) {
        data.add(AnalyticsConstants_1.AnalyticsConstants.Fields.LOG_TYPE, AnalyticsConstants_1.AnalyticsConstants.LogTypes.OPERATIONS);
        var finalPayload = data.merge(Operations.globals);
        Operations.logOperationsEvent(finalPayload);
    };
    Operations.logAuthenticationConfigurationSuccessful = function (data) {
        data.add(AnalyticsConstants_1.AnalyticsConstants.Fields.EVENT_NAME, AnalyticsConstants_1.AnalyticsConstants.Events.AUTHENTICATION_CONFIGURATION_SUCCESSFUL);
        data.add(AnalyticsConstants_1.AnalyticsConstants.Fields.LOG_TYPE, AnalyticsConstants_1.AnalyticsConstants.LogTypes.OPERATIONS);
        var finalPayload = data.merge(Operations.globals);
        Operations.logOperationsEvent(finalPayload);
    };
    Operations.logCancelSignIn = function (data) {
        data.add(AnalyticsConstants_1.AnalyticsConstants.Fields.EVENT_NAME, AnalyticsConstants_1.AnalyticsConstants.Events.CANCEL_SIGN_IN);
        data.add(AnalyticsConstants_1.AnalyticsConstants.Fields.LOG_TYPE, AnalyticsConstants_1.AnalyticsConstants.LogTypes.OPERATIONS);
        var finalPayload = data.merge(Operations.globals);
        Operations.logOperationsEvent(finalPayload);
    };
    Operations.logClearSavedSignInData = function (data) {
        data.add(AnalyticsConstants_1.AnalyticsConstants.Fields.EVENT_NAME, AnalyticsConstants_1.AnalyticsConstants.Events.CLEAR_SAVED_SIGN_IN_DATA);
        data.add(AnalyticsConstants_1.AnalyticsConstants.Fields.LOG_TYPE, AnalyticsConstants_1.AnalyticsConstants.LogTypes.OPERATIONS);
        var finalPayload = data.merge(Operations.globals);
        Operations.logOperationsEvent(finalPayload);
    };
    Operations.logDeviceInfo = function (data) {
        data.add(AnalyticsConstants_1.AnalyticsConstants.Fields.EVENT_NAME, AnalyticsConstants_1.AnalyticsConstants.Events.DEVICE_INFO);
        data.add(AnalyticsConstants_1.AnalyticsConstants.Fields.LOG_TYPE, AnalyticsConstants_1.AnalyticsConstants.LogTypes.OPERATIONS);
        var finalPayload = data.merge(Operations.globals);
        Operations.logOperationsEvent(finalPayload);
    };
    Operations.logDoSigninRetry = function (data) {
        data.add(AnalyticsConstants_1.AnalyticsConstants.Fields.EVENT_NAME, AnalyticsConstants_1.AnalyticsConstants.Events.DO_SIGNIN_RETRY);
        data.add(AnalyticsConstants_1.AnalyticsConstants.Fields.LOG_TYPE, AnalyticsConstants_1.AnalyticsConstants.LogTypes.OPERATIONS);
        var finalPayload = data.merge(Operations.globals);
        Operations.logOperationsEvent(finalPayload);
    };
    Operations.logFailureLoadingChannels = function (data) {
        data.add(AnalyticsConstants_1.AnalyticsConstants.Fields.EVENT_NAME, AnalyticsConstants_1.AnalyticsConstants.Events.FAILURE_LOADING_CHANNELS);
        data.add(AnalyticsConstants_1.AnalyticsConstants.Fields.LOG_TYPE, AnalyticsConstants_1.AnalyticsConstants.LogTypes.OPERATIONS);
        var finalPayload = data.merge(Operations.globals);
        Operations.logOperationsEvent(finalPayload);
    };
    Operations.logFailureLoadingGuideRows = function (data) {
        data.add(AnalyticsConstants_1.AnalyticsConstants.Fields.EVENT_NAME, AnalyticsConstants_1.AnalyticsConstants.Events.FAILURE_LOADING_GUIDE_ROWS);
        data.add(AnalyticsConstants_1.AnalyticsConstants.Fields.LOG_TYPE, AnalyticsConstants_1.AnalyticsConstants.LogTypes.OPERATIONS);
        var finalPayload = data.merge(Operations.globals);
        Operations.logOperationsEvent(finalPayload);
    };
    Operations.logFailureLoadingPreview = function (data) {
        data.add(AnalyticsConstants_1.AnalyticsConstants.Fields.EVENT_NAME, AnalyticsConstants_1.AnalyticsConstants.Events.FAILURE_LOADING_PREVIEW);
        data.add(AnalyticsConstants_1.AnalyticsConstants.Fields.LOG_TYPE, AnalyticsConstants_1.AnalyticsConstants.LogTypes.OPERATIONS);
        var finalPayload = data.merge(Operations.globals);
        Operations.logOperationsEvent(finalPayload);
    };
    Operations.logFinishLoadingChannels = function (data) {
        data.add(AnalyticsConstants_1.AnalyticsConstants.Fields.EVENT_NAME, AnalyticsConstants_1.AnalyticsConstants.Events.FINISH_LOADING_CHANNELS);
        data.add(AnalyticsConstants_1.AnalyticsConstants.Fields.LOG_TYPE, AnalyticsConstants_1.AnalyticsConstants.LogTypes.OPERATIONS);
        var finalPayload = data.merge(Operations.globals);
        Operations.logOperationsEvent(finalPayload);
    };
    Operations.logFinishLoadingGuide = function (data) {
        data.add(AnalyticsConstants_1.AnalyticsConstants.Fields.EVENT_NAME, AnalyticsConstants_1.AnalyticsConstants.Events.FINISH_LOADING_GUIDE);
        data.add(AnalyticsConstants_1.AnalyticsConstants.Fields.LOG_TYPE, AnalyticsConstants_1.AnalyticsConstants.LogTypes.OPERATIONS);
        var finalPayload = data.merge(Operations.globals);
        Operations.logOperationsEvent(finalPayload);
    };
    Operations.logFinishLoadingGuideRows = function (data) {
        data.add(AnalyticsConstants_1.AnalyticsConstants.Fields.EVENT_NAME, AnalyticsConstants_1.AnalyticsConstants.Events.FINISH_LOADING_GUIDE_ROWS);
        data.add(AnalyticsConstants_1.AnalyticsConstants.Fields.LOG_TYPE, AnalyticsConstants_1.AnalyticsConstants.LogTypes.OPERATIONS);
        var finalPayload = data.merge(Operations.globals);
        Operations.logOperationsEvent(finalPayload);
    };
    Operations.logFinishLoadingPreview = function (data) {
        data.add(AnalyticsConstants_1.AnalyticsConstants.Fields.EVENT_NAME, AnalyticsConstants_1.AnalyticsConstants.Events.FINISH_LOADING_PREVIEW);
        data.add(AnalyticsConstants_1.AnalyticsConstants.Fields.LOG_TYPE, AnalyticsConstants_1.AnalyticsConstants.LogTypes.OPERATIONS);
        var finalPayload = data.merge(Operations.globals);
        Operations.logOperationsEvent(finalPayload);
    };
    Operations.logHandleLoginFail = function (data) {
        data.add(AnalyticsConstants_1.AnalyticsConstants.Fields.EVENT_NAME, AnalyticsConstants_1.AnalyticsConstants.Events.HANDLE_LOGIN_FAIL);
        data.add(AnalyticsConstants_1.AnalyticsConstants.Fields.LOG_TYPE, AnalyticsConstants_1.AnalyticsConstants.LogTypes.OPERATIONS);
        var finalPayload = data.merge(Operations.globals);
        Operations.logOperationsEvent(finalPayload);
    };
    Operations.logHeartBeat = function (data) {
        data.add(AnalyticsConstants_1.AnalyticsConstants.Fields.EVENT_NAME, AnalyticsConstants_1.AnalyticsConstants.Events.HEART_BEAT);
        data.add(AnalyticsConstants_1.AnalyticsConstants.Fields.LOG_TYPE, AnalyticsConstants_1.AnalyticsConstants.LogTypes.OPERATIONS);
        var finalPayload = data.merge(Operations.globals);
        Operations.logOperationsEvent(finalPayload);
    };
    Operations.logLoginWithSavedSamlTkn = function (data) {
        data.add(AnalyticsConstants_1.AnalyticsConstants.Fields.EVENT_NAME, AnalyticsConstants_1.AnalyticsConstants.Events.LOGIN_WITH_SAVED_SAML_TKN);
        data.add(AnalyticsConstants_1.AnalyticsConstants.Fields.LOG_TYPE, AnalyticsConstants_1.AnalyticsConstants.LogTypes.OPERATIONS);
        var finalPayload = data.merge(Operations.globals);
        Operations.logOperationsEvent(finalPayload);
    };
    Operations.logNetInfo = function (data) {
        data.add(AnalyticsConstants_1.AnalyticsConstants.Fields.EVENT_NAME, AnalyticsConstants_1.AnalyticsConstants.Events.NET_INFO);
        data.add(AnalyticsConstants_1.AnalyticsConstants.Fields.LOG_TYPE, AnalyticsConstants_1.AnalyticsConstants.LogTypes.OPERATIONS);
        var finalPayload = data.merge(Operations.globals);
        Operations.logOperationsEvent(finalPayload);
    };
    Operations.logOnSignInQueryError = function (data) {
        data.add(AnalyticsConstants_1.AnalyticsConstants.Fields.EVENT_NAME, AnalyticsConstants_1.AnalyticsConstants.Events.ON_SIGN_IN_QUERY_ERROR);
        data.add(AnalyticsConstants_1.AnalyticsConstants.Fields.LOG_TYPE, AnalyticsConstants_1.AnalyticsConstants.LogTypes.OPERATIONS);
        var finalPayload = data.merge(Operations.globals);
        Operations.logOperationsEvent(finalPayload);
    };
    Operations.logOnSignInQueryResponse = function (data) {
        data.add(AnalyticsConstants_1.AnalyticsConstants.Fields.EVENT_NAME, AnalyticsConstants_1.AnalyticsConstants.Events.ON_SIGN_IN_QUERY_RESPONSE);
        data.add(AnalyticsConstants_1.AnalyticsConstants.Fields.LOG_TYPE, AnalyticsConstants_1.AnalyticsConstants.LogTypes.OPERATIONS);
        var finalPayload = data.merge(Operations.globals);
        Operations.logOperationsEvent(finalPayload);
    };
    Operations.logOnSignOutDone = function (data) {
        data.add(AnalyticsConstants_1.AnalyticsConstants.Fields.EVENT_NAME, AnalyticsConstants_1.AnalyticsConstants.Events.ON_SIGN_OUT_DONE);
        data.add(AnalyticsConstants_1.AnalyticsConstants.Fields.LOG_TYPE, AnalyticsConstants_1.AnalyticsConstants.LogTypes.OPERATIONS);
        var finalPayload = data.merge(Operations.globals);
        Operations.logOperationsEvent(finalPayload);
    };
    Operations.logReconnect = function (data) {
        data.add(AnalyticsConstants_1.AnalyticsConstants.Fields.EVENT_NAME, AnalyticsConstants_1.AnalyticsConstants.Events.RECONNECT);
        data.add(AnalyticsConstants_1.AnalyticsConstants.Fields.LOG_TYPE, AnalyticsConstants_1.AnalyticsConstants.LogTypes.OPERATIONS);
        var finalPayload = data.merge(Operations.globals);
        Operations.logOperationsEvent(finalPayload);
    };
    Operations.logSignInError = function (data) {
        data.add(AnalyticsConstants_1.AnalyticsConstants.Fields.EVENT_NAME, AnalyticsConstants_1.AnalyticsConstants.Events.SIGN_IN_ERROR);
        data.add(AnalyticsConstants_1.AnalyticsConstants.Fields.LOG_TYPE, AnalyticsConstants_1.AnalyticsConstants.LogTypes.OPERATIONS);
        var finalPayload = data.merge(Operations.globals);
        Operations.logOperationsEvent(finalPayload);
    };
    Operations.logSignInFailed = function (data) {
        data.add(AnalyticsConstants_1.AnalyticsConstants.Fields.EVENT_NAME, AnalyticsConstants_1.AnalyticsConstants.Events.SIGN_IN_FAILED);
        data.add(AnalyticsConstants_1.AnalyticsConstants.Fields.LOG_TYPE, AnalyticsConstants_1.AnalyticsConstants.LogTypes.OPERATIONS);
        var finalPayload = data.merge(Operations.globals);
        Operations.logOperationsEvent(finalPayload);
    };
    Operations.logSignOut = function (data) {
        data.add(AnalyticsConstants_1.AnalyticsConstants.Fields.EVENT_NAME, AnalyticsConstants_1.AnalyticsConstants.Events.SIGN_OUT);
        data.add(AnalyticsConstants_1.AnalyticsConstants.Fields.LOG_TYPE, AnalyticsConstants_1.AnalyticsConstants.LogTypes.OPERATIONS);
        var finalPayload = data.merge(Operations.globals);
        Operations.logOperationsEvent(finalPayload);
    };
    Operations.logSignOutDone = function (data) {
        data.add(AnalyticsConstants_1.AnalyticsConstants.Fields.EVENT_NAME, AnalyticsConstants_1.AnalyticsConstants.Events.SIGN_OUT_DONE);
        data.add(AnalyticsConstants_1.AnalyticsConstants.Fields.LOG_TYPE, AnalyticsConstants_1.AnalyticsConstants.LogTypes.OPERATIONS);
        var finalPayload = data.merge(Operations.globals);
        Operations.logOperationsEvent(finalPayload);
    };
    Operations.logStartLoadingChannels = function (data) {
        data.add(AnalyticsConstants_1.AnalyticsConstants.Fields.EVENT_NAME, AnalyticsConstants_1.AnalyticsConstants.Events.START_LOADING_CHANNELS);
        data.add(AnalyticsConstants_1.AnalyticsConstants.Fields.LOG_TYPE, AnalyticsConstants_1.AnalyticsConstants.LogTypes.OPERATIONS);
        var finalPayload = data.merge(Operations.globals);
        Operations.logOperationsEvent(finalPayload);
    };
    Operations.logStartLoadingGuide = function (data) {
        data.add(AnalyticsConstants_1.AnalyticsConstants.Fields.EVENT_NAME, AnalyticsConstants_1.AnalyticsConstants.Events.START_LOADING_GUIDE);
        data.add(AnalyticsConstants_1.AnalyticsConstants.Fields.LOG_TYPE, AnalyticsConstants_1.AnalyticsConstants.LogTypes.OPERATIONS);
        var finalPayload = data.merge(Operations.globals);
        Operations.logOperationsEvent(finalPayload);
    };
    Operations.logStartLoadingGuideRows = function (data) {
        data.add(AnalyticsConstants_1.AnalyticsConstants.Fields.EVENT_NAME, AnalyticsConstants_1.AnalyticsConstants.Events.START_LOADING_GUIDE_ROWS);
        data.add(AnalyticsConstants_1.AnalyticsConstants.Fields.LOG_TYPE, AnalyticsConstants_1.AnalyticsConstants.LogTypes.OPERATIONS);
        var finalPayload = data.merge(Operations.globals);
        Operations.logOperationsEvent(finalPayload);
    };
    Operations.logStartLoadingPreviews = function (data) {
        data.add(AnalyticsConstants_1.AnalyticsConstants.Fields.EVENT_NAME, AnalyticsConstants_1.AnalyticsConstants.Events.START_LOADING_PREVIEW);
        data.add(AnalyticsConstants_1.AnalyticsConstants.Fields.LOG_TYPE, AnalyticsConstants_1.AnalyticsConstants.LogTypes.OPERATIONS);
        var finalPayload = data.merge(Operations.globals);
        Operations.logOperationsEvent(finalPayload);
    };
    Operations.logStartSigninRetry = function (data) {
        data.add(AnalyticsConstants_1.AnalyticsConstants.Fields.EVENT_NAME, AnalyticsConstants_1.AnalyticsConstants.Events.START_SIGNIN_RETRY);
        data.add(AnalyticsConstants_1.AnalyticsConstants.Fields.LOG_TYPE, AnalyticsConstants_1.AnalyticsConstants.LogTypes.OPERATIONS);
        var finalPayload = data.merge(Operations.globals);
        Operations.logOperationsEvent(finalPayload);
    };
    Operations.logSystemMemoryInfo = function (data) {
        data.add(AnalyticsConstants_1.AnalyticsConstants.Fields.EVENT_NAME, AnalyticsConstants_1.AnalyticsConstants.Events.SYSTEM_MEMORY_INFO);
        data.add(AnalyticsConstants_1.AnalyticsConstants.Fields.LOG_TYPE, AnalyticsConstants_1.AnalyticsConstants.LogTypes.OPERATIONS);
        var finalPayload = data.merge(Operations.globals);
        Operations.logOperationsEvent(finalPayload);
    };
    Operations.logWelcomeScreen = function (data) {
        data.add(AnalyticsConstants_1.AnalyticsConstants.Fields.EVENT_NAME, AnalyticsConstants_1.AnalyticsConstants.Events.WELCOME_SCREEN);
        data.add(AnalyticsConstants_1.AnalyticsConstants.Fields.LOG_TYPE, AnalyticsConstants_1.AnalyticsConstants.LogTypes.OPERATIONS);
        var finalPayload = data.merge(Operations.globals);
        Operations.logOperationsEvent(finalPayload);
    };
    Operations.setEventQueueSize = function (size) {
        Operations.eventQueue.setSize(size);
    };
    Operations.noConsole = function () {
        this.logger.noConsole = true;
    };
    Operations.logger = new OperationsLogger_1.OperationsLogger();
    Operations.eventQueue = new EventQueue_1.EventQueue();
    Operations.isSynchronised = true;
    Operations.eventQueuehandler = new EventQueueHandler_1.EventQueueHandler(Operations.logger, Operations.eventQueue);
    return Operations;
}());
exports.Operations = Operations;
